import { useCallback, useEffect, useLayoutEffect, useState } from 'react';
import { useAppDispatch } from 'src/AppContext';
import { useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import InfiniteScroll from 'react-infinite-scroller';
import { isKorean } from 'src/services/util';
import dayjs from 'dayjs';

const ITEM_LENGTH = 10;

type Props = {
  list: NoticeItem[];
};

export default function Notice({ list }: Props): JSX.Element {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useCustomHistory();
  const [items, setItems] = useState([] as NoticeItem[]);
  const [pageIndex, setPageIndex] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  useLayoutEffect(() => {
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
    };
  }, []);

  useEffect(() => {
    if (list.length > 0) {
      onLoadMore();
    }
  }, [list]);

  const onClickItem = useCallback((e) => {
    e.stopPropagation();
    history.push(`/notice/${e.currentTarget.dataset.id}`);
  }, []);

  const onLoadMore = useCallback(() => {
    const nextItems = list.slice(ITEM_LENGTH * pageIndex, ITEM_LENGTH * (pageIndex + 1));
    setItems(items.concat(nextItems));
    if (list.length < ITEM_LENGTH * (pageIndex + 1)) {
      setHasMore(false);
    } else {
      setPageIndex(pageIndex + 1);
      setHasMore(true);
    }
  }, [pageIndex, list]);

  return (
    <>
      <div className="container">
        <div className="mt-6 N_20_R">{t('notice/title')}</div>
      </div>
      <ul className="mt-2">
        {list.length > 0 && (
          <InfiniteScroll pageStart={0} threshold={0} loadMore={onLoadMore} hasMore={hasMore} loader={<div key={0}></div>}>
            {items.map((item, index) => (
              <li
                data-id={item.id}
                key={index}
                className={'container py-5 cursor-pointer' + (index === items.length - 1 ? '' : ' border-b border-ice-blue')}
                onClick={onClickItem}
              >
                <div className="N_14_R">{item[isKorean() ? 'koTitle' : 'enTitle']}</div>
                <div className="mt-2 N_12_R text-brown-grey">{dayjs(item.updateDate).format('YYYY.MM.DD HH.mm')}</div>
              </li>
            ))}
          </InfiniteScroll>
        )}
      </ul>
    </>
  );
}
